/**
 * useIsEmbedded · true if the current page is loaded inside a
 * Corporate Portal drawer (i.e. the parent passed `?embed=drawer`).
 *
 * When true, pillar pages should hide their top-nav chrome
 * (ConciergeOnDutyPill · CrossSurfaceNav · ConciergeSurfaceMenu),
 * their global hero, and any redundant "by Concierge®" pills — the
 * corporate drawer already provides that context via its own header.
 *
 * Safe on SSR (checks `typeof window`).
 */
import { useEffect, useState } from "react";

export function useIsEmbedded() {
  const [embedded, setEmbedded] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const p = new URL(window.location.href).searchParams;
      const val = (p.get("embed") || "").toLowerCase();
      setEmbedded(val === "drawer" || val === "iframe" || val === "1");
    } catch (_) { /* ignore */ }
  }, []);
  return embedded;
}

export default useIsEmbedded;
